export default {"src":"/_next/static/media/google-review.581c751b.svg","height":89,"width":148,"blurWidth":0,"blurHeight":0};